module.exports = __webpack_public_path__ + "cg.c2f55ad5.svg";